<template>
  <div class="bg-dark" style="padding-top: 6rem; padding-bottom: 1.5rem">
    <div class="container">
      <header>
        <div class="row pb-5">
          <div class="col-md-8">
            <h1 class="header-title">Lass dich hören!</h1>
            <h2 class="fw-normal fs-3">
              Wir sind Voice Art Productions.
              <div class="pt-2">
                Unsere Mission: Alles, was dein Podcast groß macht! Wir bieten
                maßgeschneiderte Produktionen, strategische Beratung und eine
                persönliche Betreuung – damit du gehört wirst!
              </div>
              <div class="pt-2">
                Hier triffst du auf Handwerk, Expertise und Leidenschaft.
              </div>
            </h2>
          </div>
        </div>
      </header>

      <main>
        <!-- Audio Plans -->
        <h1 class="text-white text-center mb-4">Audio Podcast</h1>
        <div class="row row-cols-1 row-cols-md-3 mb-5 text-center">
          <PricingCard
            v-for="plan in audioPlans"
            :key="plan.id"
            v-bind="plan"
            :price="getPrice(plan.id)"
            :mastered-audio-file="masteredAudioFile"
            :original-audio-file="originalAudioFile"
            @price-update="handlePriceUpdate"
          />
        </div>

        <!-- Video Plans -->
        <h1 class="text-white text-center mb-4">Video Podcast</h1>
        <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
          <PricingCard
            v-for="plan in videoPlans"
            :key="plan.id"
            v-bind="plan"
            :price="getPrice(plan.id)"
            @price-update="handlePriceUpdate"
          />
        </div>

        <ComparePlansNew />

        <!-- Kostprobe -->
        <div id="soundcheck" class="text-center fs-3 text-white fw-bold">
          <div
            class="pb-4 fw-bolder lh-sm"
            :class="{
              'gif-header-mobile': viewStore.isMobile,
              'gif-header': !viewStore.isMobile,
            }"
          >
            Wie klingt das?
          </div>

          <div
            class="mx-auto py-3"
            :class="{ 'w-75': viewStore.isMobile, 'w-25': !viewStore.isMobile }"
          >
            <img
              class="mx-auto img-fluid rounded-4"
              src="../assets/videos/cat-dj-pizza.gif"
              alt="DJ Cat mit Pizza"
            />
          </div>

          <div
            class="mx-auto pt-3"
            :class="{
              'w-100': viewStore.isMobile,
              'w-75': !viewStore.isMobile,
            }"
          >
            <span>Lass dich kostenlos von unserer Qualität überzeugen.</span>
          </div>

          <div class="pt-5 fw-normal fs-5">
            So klingt's nach unserem Feinschliff
          </div>

          <div class="mt-3">
            <AudioPlayer
              :src="masteredAudioFile"
              :original-src="originalAudioFile"
              :class="{
                'w-100': viewStore.isMobile,
                'w-50': !viewStore.isMobile,
              }"
            />
          </div>

          <a
            id="kostprobe-podcast"
            class="mt-5 btn btn-primary btn-lg px-4"
            href="mailto:jakob@voiceart-productions.com?subject=Kostprobe - Upload Link&body=Hey Jakob, %0D%0A %0D%0A könntest du mir bitte einen Drive Link zum Upload meines Podcasts für die Kostprobe zukommen lassen? %0D%0A %0D%0A Beste Grüße"
            role="button"
          >
            Schick uns jetzt deine Aufnahme
          </a>

          <p class="pt-4 center" :class="{ 'w-50': !viewStore.isMobile }">
            Wir verwandeln deine Rohaufnahme in eine hochwertige Podcastfolge!
            Lade deine Aufnahme hier hoch und erhalte eine individuell
            produzierte Podcastfolge inkl. Feedback von uns zurück!
          </p>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { audioPlans, videoPlans } from "~/data/pricing";
import PricingCard from "./pricing/PricingCard.vue";
import ComparePlansNew from "./ComparePlansNew.vue";
import { useViewStore } from "~/stores/ViewStore";
import AudioPlayer from "./AudioPlayer.vue";

const viewStore = useViewStore();

// Audio files (place files in public/audio/ directory)
const masteredAudioFile = "/audio/mastered.mp3";
const originalAudioFile = "/audio/original.mp3";

// Dynamic pricing state
const prices = ref<Record<string, number>>({
  "audio-basic": 60,
  "audio-pro": 140,
  "audio-hosting": 190,
  "video-basic": 190,
  "video-pro": 250,
  "video-hosting": 300,
});

/**
 * Get price for a specific plan
 */
const getPrice = (planId: string): number => {
  return prices.value[planId] || 0;
};

/**
 * Handle price updates from child components
 */
const handlePriceUpdate = (data: {
  packageType: string;
  numberOfSpeakers: number;
  episodeDuration: number;
  price: number;
}) => {
  if (data.packageType) {
    // Map the package type to the correct plan ID
    const planMap: Record<string, string> = {
      "audio-pro": "audio-pro",
      "audio-pro-hosting": "audio-hosting",
      "video-basic": "video-basic",
      "video-pro": "video-pro",
      "video-pro-hosting": "video-hosting",
    };

    const planId = planMap[data.packageType];
    if (planId) {
      prices.value[planId] = data.price;
    }
  }
};
</script>

<style scoped>
.header-title {
  color: white;
  font-weight: 900 !important;
  font-size: 4rem;
}

h2 {
  color: rgb(185, 185, 185);
}

p {
  color: #747474;
  font-size: 1.1rem;
}

.audio-secondary-btn:hover {
  color: white;
}

.gif-header {
  font-size: 6rem;
}

.gif-header-mobile {
  font-size: 4rem;
}

#soundcheck {
  padding: 8rem 0 4rem;
}

.info-text {
  color: #8a8a8a;
}

.center {
  margin: 0 auto;
}
</style>
